export const Kg = () => 'kg';
